
import Vue from 'vue'

type SupportedCurrency = {
  name: string;
  code: string;
}
const supportedCurrencies: SupportedCurrency[] = [
  { name: 'Australian Dollars', code: 'aud' },
  { name: 'New Zealand Dollars', code: 'nzd' },
  { name: 'US Dollars', code: 'usd' }
]
export default Vue.extend({
  props: {
    value: { type: String, required: true }
  },
  data() {
    return {
      currencies: supportedCurrencies
    }
  },
  computed: {
    dense(): boolean {
      return this.$vuetify.breakpoint.mdAndDown
    }
  },
  methods: {
    displayCurrency(currency: SupportedCurrency) {
      if (this.dense) {
        return currency.code.toLocaleUpperCase()
      } else {
        return `${currency.name} (${currency.code.toLocaleUpperCase()})`
      }
    }
  }
})
